import moment from "moment";

export const getOpsreviewDayOfWeek = (day: number = 3) => {
  const today = moment().isoWeekday();

  if (today <= day) {
    return moment().isoWeekday(day);
  }
  return moment().add(1, "weeks").isoWeekday(day);
};
